export const nativeCurrency = {
  name: 'Water',
  symbol: 'Water',
  decimals: 18,
};
